import { SocialProof } from './../../models/social-proof.model';
import { Component, Input, OnInit } from '@angular/core';
import { Product } from '@infrab4a/connect';

@Component({
  selector: 'glam-social-proof-card',
  templateUrl: './social-proof-card.component.html',
  styleUrls: ['./social-proof-card.component.scss']
})
export class SocialProofCardComponent implements OnInit {

  @Input() social: SocialProof;

  constructor() { }

  ngOnInit(): void {
  }

}
